// src/API/emblem.js
const apiUrl = process.env.REACT_APP_API_URL;

// ✅ Fetch user's current emblem & color
export const fetchUserEmblem = async () => {
  const userId = sessionStorage.getItem("user_id");
  if (!userId) {
    console.error("Error: No user ID found in sessionStorage.");
    return { success: false, message: "User ID is required." };
  }
  try {
    console.log(`Fetching emblem for user ID: ${userId}`);
    const response = await fetch(`${apiUrl}/user/customization?user_id=${userId}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error("Error fetching emblem:", errorData);
      return { success: false, message: errorData.message };
    }

    const data = await response.json();
    console.log("Fetched user emblem:", data);
    return { success: true, data: data.data };
  } catch (error) {
    console.error("Unexpected error while fetching emblem:", error.message);
    return { success: false, message: "An unexpected error occurred." };
  }
};

// ✅ Save the user's emblem & color
export const saveUserCustomization = async (emblemId, color) => {
  
  const userId = sessionStorage.getItem("user_id");
  if (!userId) {
    console.error("Error: No user ID found in sessionStorage.");
    return { success: false, message: "User not logged in. Please log in again." };
  }
  if (!emblemId || !color) {
    console.error("Error: Emblem or color is missing.");
    return { success: false, message: "Emblem and color are required." };
  }
  try {
    console.log(`Saving customization for user ID: ${userId}, emblemId=${emblemId}, color=${color}`);
    const response = await fetch(`${apiUrl}/user/customize`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ user_id: userId, emblem_id: emblemId, color: color }),
    });
    if (!response.ok) {
      const errorData = await response.json();
      console.error("Error saving customization:", errorData);
      return { success: false, message: errorData.message };
    }
    const data = await response.json();
    console.log("Customization saved successfully:", data);
    return data;
  } catch (error) {
    console.error("Unexpected error while saving customization:", error.message);
    return { success: false, message: "An unexpected error occurred." };
  }

  

};

// ✅ Construct the emblem image path dynamically
export const getEmblemImagePath = (emblemId, color) => {
  return `../assets/emblems/Coat_of_arms_${emblemId}_${color}.png`;
};


